'use strict';

var myredemptionapp = angular.module("myredemptionapp", []);

(function () {
    'use strict';

    myredemptionapp.service("dataService", dataService);
    dataService.$inject = ['$http', '$q'];

    myredemptionapp.controller("myredemptionCtrl", myredemptionCtrl);
    myredemptionCtrl.$inject = ['dataService', '$timeout', '$window'];

    function myredemptionCtrl(dataService, $timeout, $window) {
        var vm = this;
        vm.page = 1;
        vm.isInit = true;
        vm.data = [];
        vm.showMore = showMore;
        vm.displayShowMore = false;
        vm.dateToString = dateToString;

        init();
        
        function loadData() {

            var req = dataService.listRedemptions(vm.page);
            
            req.then(function (res) {                
                vm.data = vm.data.concat(res.data.Data);
                vm.isInit = false;
                vm.displayShowMore = res.data.Info.RecordsCount > vm.data.length;

                vm.data.forEach(function (c) {
                    if (c.CategoryIcon.endsWith('svg')) {
                        loadExternalSvg(c.ID + '__icon__svg', c.CategoryIcon);
                    }
                });
            });
        }

        function showMore() {
            vm.page++;
            loadData();
        }
        
        function init() {
            loadData();
        }

        function dateToString(value) {
            return moment(value).format("Do MMM YYYY");
        }
    };
})();


